import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const GradeIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 35.01 22.35"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 22.35)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <path d="M2.68 7.85 18.64.75l8.35 3.8 7.27 3.3-15.62 6.95z" />
      <path d="M8.73 13.67v4.6s1.73 3.33 9.29 3.33 9.9-3.33 9.9-3.33v-4.6" />
      <path d="M15.64 7.1 4.9 9.97l-1.85 5.89" />
      <path d="m4.31 11.7-3.25 3.1M4.23 11.8l.91 4.4" fill="#fff" />
    </SVG>
  );
};
